/**
 * Treatments Grid Dynamic Generator
 * 
 * 從 Ghost 的 Secondary Navigation 數據中解析並生成 treatments grid
 * 使用與 mega-menu 相同的數據源和邏輯
 */

(function ($) {
    'use strict';

    // 檢查字串是否為全大寫（允許空格和 & 符號）
    function isAllUpperCase(str) {
        const cleanStr = str.replace(/[\s&]/g, '');
        return cleanStr === cleanStr.toUpperCase() && /[A-Z]/.test(cleanStr) && !/[\/]/.test(cleanStr);
    }

    // 從導航數據中解析分類結構
    function parseTreatmentsData(navigationItems) {
        const categories = [];
        let currentCategory = null;

        navigationItems.forEach(item => {
            const label = item.label.trim();
            const dashMatch = label.match(/^([-–—]+)\s*/);
            const nameWithoutDash = label.replace(/^[-–—]+\s*/, '');

            let isSubItem = false;
            let level = 1;

            if (dashMatch) {
                isSubItem = true;
                level = dashMatch[1].length;
            } else if (!isAllUpperCase(nameWithoutDash) || nameWithoutDash.toUpperCase() === 'M22 AOPT') {
                // 如果不是全大寫，或者剛好是 'M22 AOPT' 這個特例，就當作子項目
                isSubItem = true;
                level = 1;
            } else {
                isSubItem = false;
            }

            if (isSubItem) {
                if (currentCategory) {
                    let url = item.url;

                    if (!url || url === '/' || url.includes('javascript:void(0)')) {
                        const slug = nameWithoutDash.toLowerCase()
                            .replace(/[^\w\s-]/g, '')
                            .trim()
                            .replace(/\s+/g, '-');
                        url = `/${slug}/`;
                    }

                    currentCategory.items.push({
                        name: nameWithoutDash,
                        url: url,
                        level: level
                    });
                }
            } else {
                if (currentCategory) {
                    categories.push(currentCategory);
                }
                currentCategory = {
                    title: nameWithoutDash,
                    items: []
                };
            }
        });

        if (currentCategory) {
            categories.push(currentCategory);
        }

        return categories;
    }

    // 處理分類標題
    function formatCategoryTitle(title) {
        return title;
    }

    // 生成 treatments grid HTML
    function generateTreatmentsGridHTML(categories) {
        if (categories.length === 0) {
            return '';
        }

        let html = '';

        categories.forEach(category => {
            html += '<div class="treatment-col">';
            html += `<h3>${formatCategoryTitle(category.title)}</h3>`;
            html += '<ul>';

            category.items.forEach(item => {
                const indentClass = item.level > 1 ? ` class="sub-level-${item.level}"` : '';
                html += `<li${indentClass}><a href="${item.url}">${item.name}</a></li>`;
            });

            html += '</ul>';
            html += '</div>';
        });

        return html;
    }

    // 初始化 treatments grid
    function initTreatmentsGrid() {
        const $container = $('.treatments-grid[data-treatments-navigation]');

        if ($container.length === 0) {
            return;
        }

        try {
            // 從 data 屬性中獲取導航數據
            const navigationItems = $container.data('treatments-navigation');

            if (!navigationItems || navigationItems.length === 0) {
                console.warn('No navigation items found for treatments grid.');
                return;
            }

            // 解析數據
            const categories = parseTreatmentsData(navigationItems);

            if (categories.length === 0) {
                console.warn('No categories parsed for treatments grid.');
                return;
            }

            // 生成 HTML
            const html = generateTreatmentsGridHTML(categories);

            // 插入到容器中
            $container.html(html);

            console.log(`Treatments grid initialized with ${categories.length} categories.`);
        } catch (error) {
            console.error('Error initializing treatments grid:', error);
        }
    }

    // 當 DOM 準備好時初始化
    $(document).ready(function () {
        initTreatmentsGrid();
    });

})(jQuery);
